/* Homepage enhancement only; products and every destination are server rendered. */
(() => {
  'use strict';
  const root = document.querySelector('#main-content.bh-home');
  if (!root) return;
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  let paused = false;
  try { paused = localStorage.getItem('byards-atmosphere-paused') === 'true'; } catch (_) { /* Optional preference. */ }
  function atmosphere() {
    root.classList.toggle('bh-atmosphere-ready', !preference.matches);
    root.classList.toggle('bh-motion-paused', paused || preference.matches || document.hidden);
    root.querySelectorAll('[data-bh-motion-toggle]').forEach(button => {
      button.hidden = preference.matches;
      button.setAttribute('aria-pressed', String(paused));
      button.textContent = paused
        ? (button.dataset.bhResumeLabel || 'Resume gentle atmosphere')
        : (button.dataset.bhPauseLabel || 'Pause gentle atmosphere');
    });
  }
  function initialise(scope) {
    scope.querySelectorAll('[data-bh-motion-toggle]').forEach(button => {
      if (button.dataset.bhReady) return;
      button.dataset.bhReady = 'true';
      button.addEventListener('click', () => {
        paused = !paused;
        try { localStorage.setItem('byards-atmosphere-paused', String(paused)); } catch (_) { /* Optional preference. */ }
        atmosphere();
      });
    });
    scope.querySelectorAll('[data-bh-tabs]').forEach(chooser => {
      if (chooser.dataset.bhReady) return;
      const tabs = Array.from(chooser.querySelectorAll('[data-bh-tab]'));
      const panels = Array.from(chooser.querySelectorAll('[data-bh-panel]'));
      const tablist = chooser.querySelector('[data-bh-tablist]');
      if (!tabs.length || tabs.length !== panels.length || !tablist) return;
      chooser.dataset.bhReady = 'true';
      function select(index, focus = false) {
        tabs.forEach((tab, i) => {
          const active = index === i;
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          panels[i].hidden = !active;
          panels[i].setAttribute('role', 'tabpanel');
          panels[i].setAttribute('aria-labelledby', tab.id);
          panels[i].tabIndex = 0;
        });
        if (focus) tabs[index].focus();
      }
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(i));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (i + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          select(next, true);
        });
      });
      chooser.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-bh-panel]');
        const index = panels.indexOf(panel);
        if (index >= 0) select(index);
      });
      tablist.setAttribute('role', 'tablist');
      tablist.hidden = false;
      select(0);
    });
    atmosphere();
  }
  if (preference.addEventListener) preference.addEventListener('change', atmosphere);
  document.addEventListener('visibilitychange', atmosphere);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('bh:season:change', event => initialise(event.detail.scope || root));
  initialise(root);
})();
